import { Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import CommonCardHeader from "../../CommonElements/CommonCardHeader/CommonCardHeader";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { getFeedbackListAction } from "../../Api/feedback";
import FeedbackTableBody from "./FeedbackTableBody";


const FeedbackTableContainer = () => {
  const [feedbacks, setFeedbacks] = useState([])
  const getFeedbacks = async () => {
    try {
      const response = await getFeedbackListAction();
      if (response.status === 'success') {
        setFeedbacks(response.payload)
      }
      else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Get user list Error!")
      }
    } catch (error) {
      toast.error("Get user list failed!");
    }
  }

  useEffect(() => {
    getFeedbacks()
  }, [])
  return (
    <Container fluid className="default-dashboard dashboard-2">
      <Row className="widget-grid">
        <Col xl="12" className="">
          <Card>
            <CommonCardHeader headClass="card-no-border pb-0" title={"Feedback List"} />
            <CardBody className="pt-0 projects px-0">
              <div className="dataTables_wrapper">
                <div className="table-responsive theme-scrollbar">
                  <Table className="table display dataTable no-footer" id="selling-product">
                    <thead>
                      <tr>
                        <th>
                          {"No"}
                        </th>
                        <th>{"Subject"}</th>
                        <th>{"Description"}</th>
                        <th>{"User Name"}</th>
                        <th>{"Submitted at"}</th>
                      </tr>
                    </thead>
                    <FeedbackTableBody feedbacks={feedbacks} />
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FeedbackTableContainer;
